<template>
  <div class="landing-wrapper">
    <v-container class="py-8 py-md-12" fluid>
      <v-row justify="center">
        <v-col cols="12" lg="10">
          <div class="section-panel">
            <div class="section-panel-header">
              <v-icon size="22" color="#ffffff">mdi-file-document-outline</v-icon>
              <span>TÉRMINOS Y CONDICIONES</span>
            </div>

            <div class="terms-page-body">
              <div v-if="loading" class="terms-state">
                <v-progress-circular indeterminate color="#c8102e" size="34" />
              </div>

              <p v-else-if="error" class="terms-state terms-state-text">
                No pudimos cargar los términos y condiciones. Intenta nuevamente
                más tarde.
              </p>

              <template v-else>
                <div class="terms-head">
                  <h2 class="terms-doc-title">{{ doc.title }}</h2>
                  <a
                    v-if="doc.pdf_url"
                    class="terms-pdf"
                    :href="doc.pdf_url"
                    target="_blank"
                    rel="noopener"
                  >
                    <v-icon size="18">mdi-file-pdf-box</v-icon>
                    DESCARGAR PDF
                  </a>
                </div>

                <terms-content :blocks="doc.blocks" />

                <p v-if="doc.updated" class="terms-updated">
                  Última actualización: {{ doc.updated }}.
                </p>
              </template>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <teatro-footer />
  </div>
</template>

<script>
import { fetchTerms } from "@/services/teatroApi";
import TermsContent from "./TermsContent.vue";

export default {
  name: "TeatroTerms",
  components: { TermsContent },
  data() {
    return {
      doc: { title: "", blocks: [], updated: "", pdf_url: "" },
      loading: true,
      error: false,
    };
  },
  async created() {
    try {
      this.doc = await fetchTerms();
    } catch (e) {
      console.error("No se pudieron cargar los términos y condiciones:", e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
/* Mismo panel que el resto de las secciones de contenido (ver Faq.vue). */
.section-panel {
  max-width: 1080px;
  margin: 0 auto;
  background: rgba(8, 5, 5, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.section-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 66px;
  padding: 0 32px;
  background: linear-gradient(90deg, #c8102e 0%, #a50d25 100%);
  color: #fff;
  font-family: var(--font-family-heading);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.4px;
}

.terms-page-body {
  padding: 28px 34px 34px;
}

.terms-state {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.terms-state-text {
  margin: 0;
  color: var(--color-theater-text-muted);
  font-family: var(--font-family-heading);
  font-size: 14px;
  text-align: center;
}

.terms-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
  padding-bottom: 18px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.terms-doc-title {
  margin: 0;
  color: #fff;
  font-family: var(--font-family-heading);
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0.6px;
}

.terms-pdf {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #ff8a9c;
  font-family: var(--font-family-heading);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.9px;
  text-decoration: none;
  white-space: nowrap;
}

.terms-pdf:hover {
  color: #fff;
}

.terms-updated {
  margin: 26px 0 0;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--color-theater-text-muted);
  font-size: 12px;
}

@media (max-width: 600px) {
  .terms-page-body {
    padding: 22px 18px 26px;
  }
}
</style>
